(function ($) {
  'use strict';

  /**
  * Main functionality should be in an 'init' function
  */
  var ambientVideoInit = function () {
    var $self = $(this);

    var $videoPlayBtn = $('.video-controls .video-play-button', $self);
    var $videoPauseBtn = $('.video-controls .video-pause-button', $self);
	  var ambientVideo = $('.f--ambient-video video');

    $videoPauseBtn.attr('disabled', 'true');

    $videoPauseBtn.on('click', pauseAmbientVideo);
    $videoPlayBtn.on('click', playAmbientVideo);

    function pauseAmbientVideo() {
      $(this).addClass('hidden');
      $(this).next('.video-button').addClass('active').focus();
      ambientVideo[0].pause();
    }

    function playAmbientVideo() {
      $(this).removeClass('active');
      $(this).prev('.video-button').removeClass('hidden').focus();
      ambientVideo[0].play();
    }
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  */
  window.DP.behaviors.ambientVideo = {
    attach: function (context) {
      $(context).find('.cc--video-controls').once('ambientVideo').each(function () {
        ambientVideoInit.apply(this);
      });
    }
  };
})(jQuery);
